import { Suspense, lazy } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProtectedRoute, useAuth } from '../../../../shared/ui';
import { UserRole } from '../../../../shared/utils/types';
import { NotFoundPage } from '../../pages/NotFoundPage';

const AdminRewardsPage = lazy(() =>
  import('../../pages/admin/AdminRewardsPage').then(m => ({
    default: m.AdminRewardsPage,
  }))
);

const ProtectedAdminRewardsPage = () => {
  const { user } = useAuth();
  if (user?.role !== UserRole.ADMIN) return <NotFoundPage />;
  return (
    <ProtectedRoute>
      <Suspense fallback={<div>Loading...</div>}>
        <AdminRewardsPage />
      </Suspense>
    </ProtectedRoute>
  );
};

export const Route = createFileRoute('/admin/rewards')({
  beforeLoad: () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw redirect({ to: '/login' });
    }
  },
  component: ProtectedAdminRewardsPage,
});
